import { faArrowUpRightFromSquare, faLink } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import VoxelButton from '../../components/voxel/Buttons/VoxelButton';
import VoxelAlertDialog, {
  VoxelAlertDialogSeverity,
} from '../../components/voxel/Dialogs/VoxelAlertDialog';
import VoxelDialog from '../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogActionButton from '../../components/voxel/Dialogs/VoxelDialogActionButton';
import VoxelDialogActionCancel from '../../components/voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActionSubmit from '../../components/voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../components/voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelSelect from '../../components/voxel/Forms/VoxelSelect';
import { VoxelPopover } from '../../components/voxel/Popover/VoxelPopover';
import { VoxelPopoverContent } from '../../components/voxel/Popover/VoxelPopoverContent';
import { VoxelPopoverTrigger } from '../../components/voxel/Popover/VoxelPopoverTrigger';
import VoxelMenuItemContainer from '../../components/voxel/PopoverMenu/VoxelMenuItemContainer';
import VoxelPopoverMenuItem from '../../components/voxel/PopoverMenu/VoxelPopoverMenuItem';

export interface ComponentsBoardProps {}

export const ComponentsBoard: React.FC<ComponentsBoardProps> = ({}) => {
  // States
  const [dialogOpen, setDialogOpen] = useState<boolean>();
  const [dialogAlert, setDialogAlert] = useState<VoxelAlertDialogSeverity>();

  return (
    <div className="flex flex-col gap-8">
      {/* Special components */}
      <div className="w-full flex flex-row flex-wrap xl:flex-nowrap gap-8 justify-start">
        <VoxelButton
          title={'Dialog'}
          endIcon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
          onClick={() => setDialogOpen(!dialogOpen)}
        />
        {dialogOpen && (
          <VoxelDialog
            title={'Dialog'}
            subtitle={'This has optional backdrop and ...'}
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            closeOnBackdrop
          >
            <VoxelDialogContent>
              <div className="basis-1/3">
                <VoxelSelect
                  id={'select'}
                  label={'Country'}
                  labelPosition={'top'}
                  placeholder={'none'}
                  options={['SWE', 'US', 'UK'].map((v) => ({ title: v, value: v }))}
                  setSelectedOption={() => {}}
                />
              </div>
            </VoxelDialogContent>
            <VoxelDialogActions>
              <VoxelDialogActionButton title={'Some action'} />
              <VoxelDialogActionCancel title={'Cancel'} onClick={() => setDialogOpen(false)} />
              <VoxelDialogActionSubmit title={'Continue'} />
            </VoxelDialogActions>
          </VoxelDialog>
        )}
        <VoxelButton
          title={'Success dialog'}
          endIcon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
          onClick={() => setDialogAlert('success')}
        />
        <VoxelButton
          title={'Warning dialog'}
          endIcon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
          onClick={() => setDialogAlert('warning')}
        />
        <VoxelButton
          title={'Error dialog'}
          endIcon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
          onClick={() => setDialogAlert('error')}
        />
        <VoxelButton
          title={'Info dialog'}
          endIcon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
          onClick={() => setDialogAlert('info')}
        />
        {!!dialogAlert && (
          <VoxelAlertDialog
            title="Alert"
            open
            onClose={() => setDialogAlert(undefined)}
            closeOnBackdrop
            severity={dialogAlert}
          >
            <VoxelDialogContent className="my-4">
              This has optional backdrop and ...
            </VoxelDialogContent>
          </VoxelAlertDialog>
        )}
        <VoxelPopover enableArrow>
          <VoxelPopoverTrigger>
            <VoxelButton title="Popover" />
          </VoxelPopoverTrigger>
          <VoxelPopoverContent>
            <VoxelMenuItemContainer>
              {[
                { title: 'Popover menu item 1', icon: faArrowUpRightFromSquare },
                { title: 'Popover menu item 2', icon: faLink },
              ].map((a, index) => (
                <VoxelPopoverMenuItem
                  icon={<FontAwesomeIcon icon={a.icon} />}
                  key={index}
                  title={a.title}
                />
              ))}
            </VoxelMenuItemContainer>
          </VoxelPopoverContent>
        </VoxelPopover>
      </div>
    </div>
  );
};

export default ComponentsBoard;
